import { storeRef } from "@/components/providers/StoreProvider"
import { useAppSelector } from "@/lib/redux/hooks"

export const useIsDesktop = () => {
  const isDesktop = useAppSelector(state => state.global.isDesktop)

  return isDesktop
}